import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Questionnaire from 'ts/common/components/questionnaire/Questionnaire';
import type { QuestionnaireContext } from 'client_react/questionnaire/QuestionnaireApp';
import QuestionnaireEmailForm from 'client_react/questionnaire/components/QuestionnaireEmailForm';
import useSaveAndSubmitQuestionnaire from 'client_react/questionnaire/hooks/useSaveAndSubmitQuestionnaire';

const QuestionnairePage: React.FC = () => {
    const { questionnaire, setQuestionnaire } = useOutletContext<QuestionnaireContext>();

    const { saveQuestionResponse, submitQuestionnaire, saving, submitting, error, savingFailed } =
        useSaveAndSubmitQuestionnaire({
            questionnairePublicId: questionnaire.publicId,
            setQuestionnaire
        });

    if (!('pages' in questionnaire)) {
        return <QuestionnaireEmailForm />;
    }

    return (
        <Questionnaire
            questionnaire={questionnaire}
            saveQuestionResponse={saveQuestionResponse}
            submitQuestionnaire={submitQuestionnaire}
            saving={saving}
            submitting={submitting}
            error={error}
            savingFailed={savingFailed}
        />
    );
};

export default QuestionnairePage;
